<template lang="html">
  <div style="padding-bottom:0">
    <toolbar class="Home__PageTeller"
      v-on:TOGGLE_SIDEBAR="toggleSidenav"
      :nombre-usuario="'Diego'"></toolbar>
    <sidebar
      ref="sidenav"
      :menu-list="menuList"
    ></sidebar>
        
      <div style="margin:20px 20px;">
        <transition name="slide-fade"
          mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
      <!-- <md-toolbar> -->
        <md-layout md-align="center" style="margin-top:120px; border-top:1px solid rgb(235, 235, 235);">
          <div style="max-width:1024px; width:1024px;">
            <md-layout style="margin:25px;">
              <md-layout>
                <md-layout md-column style="color: #767676">
                <b>{{empresa.nombre}}</b>
                <br>{{empresa.direccion}} {{empresa.num_ext}} ({{empresa.num_int}})
                <br>{{empresa.colonia}}, {{empresa.cp}}
                <br>{{empresa.poblacion}}, {{empresa.entfed}}, {{empresa.pais}}
                <br>{{empresa.email}}
                <br>{{empresa.telefono}}</td>
                </md-layout>
              </md-layout>
              <md-layout md-column style="color: rgb(118, 118, 118); margin: 50px" md-align="end">
                <md-layout md-align="end" style="margin-right: 35px;">
                  <div style="text-align:center">
                  <a style="color: rgb(118, 118, 118);" target="_blank" href="https://imagen.stshop.mx/ARCOS/IMAGEN/TERMINOS%20Y%20CONDICIONES.pdf">Terminos y Condiciones</a>
                  <br/>
                  <a style="color: rgb(118, 118, 118);" target="_blank" href="https://imagen.stshop.mx/ARCOS/IMAGEN/AVISO%20DE%20PRIVACIDAD.PDF">Aviso de Privacidad</a>
                  </div>
                </md-layout>
                <md-layout md-align="end" style="margin-right: 50px;">
                  <md-button md-menu-trigger class="cart_button" style="min-width:50px">
                      <svg viewBox="0 0 32 32" role="img" aria-label="Ir a Facebook" focusable="false" 
                      style="height: 18px; width: 18px; display: block; fill: rgb(118, 118, 118);"><path d="m8 14.41v-4.17c0-.42.35-.81.77-.81h2.52v-2.08c0-4.84 2.48-7.31 7.42-7.35 1.65 0 3.22.21 4.69.64.46.14.63.42.6.88l-.56 4.06c-.04.18-.14.35-.32.53-.21.11-.42.18-.63.14-.88-.25-1.78-.35-2.8-.35-1.4 0-1.61.28-1.61 1.73v1.8h4.52c.42 0 .81.42.81.88l-.35 4.17c0 .42-.35.71-.77.71h-4.21v16c0 .42-.35.81-.77.81h-5.21c-.42 0-.8-.39-.8-.81v-16h-2.52a.78.78 0 0 1 -.78-.78" fill-rule="evenodd"></path></svg>
                  </md-button>
                  <md-button md-menu-trigger class="cart_button" style="min-width:50px">
                      <svg viewBox="0 0 32 32" role="img" aria-label="Ir a Twitter" 
                      focusable="false" style="height: 18px; width: 18px; display: block; fill: rgb(118, 118, 118);">
                      <path d="m31 6.36c-1.16.49-2.32.82-3.55.95 1.29-.76 2.22-1.87 2.72-3.38a13.05 13.05 0 0 1 -3.91 1.51c-1.23-1.28-2.75-1.94-4.51-1.94-3.41 0-6.17 2.73-6.17 6.12 0 .49.07.95.17 1.38-4.94-.23-9.51-2.6-12.66-6.38-.56.95-.86 1.97-.86 3.09 0 2.07 1.03 3.91 2.75 5.06-1-.03-1.92-.3-2.82-.76v.07c0 2.89 2.12 5.42 4.94 5.98-.63.17-1.16.23-1.62.23-.3 0-.7-.03-1.13-.13a6.07 6.07 0 0 0 5.74 4.24c-2.22 1.74-4.78 2.63-7.66 2.63-.56 0-1.06-.03-1.43-.1 2.85 1.84 6 2.76 9.41 2.76 7.29 0 12.83-4.01 15.51-9.3 1.36-2.66 2.02-5.36 2.02-8.09v-.46c-.03-.17-.03-.3-.03-.33a12.66 12.66 0 0 0 3.09-3.16" fill-rule="evenodd">
                      </path></svg>
                  </md-button>

                </md-layout>
                <md-layout v-show="false">sthshop,stshop, tienda, tienda en linea, punto de venta, facturacion, sistema de administracion, administracion, software, superticket, super ticket, compart, admin, shop, computadoras, computadora, terminales, terminal, codigo de barras, impresora, lector, tickets, facturas, cfd, cfdi</md-layout>
              </md-layout>
          </md-layout>
          <md-button class="md-fab md-fab-bottom-right" style="background-color:#00E676; position:fixed" @click.native="goWhatsapp()">
            <!-- <md-icon>chat</md-icon> -->
            <img src="../assets/img/whatsapp.png" style="max-width:45px; margin-top:-2px; margin-left:2px" />
          </md-button>
          <!-- <md-speed-dial md-open="hover" md-direction="right" class="md-fab-bottom-left">
            <md-button class="md-fab" @click.native="goWhatsapp()" md-fab-trigger style="background-color:#00E676">
              <md-icon>chat</md-icon>
            </md-button>
          </md-speed-dial> -->
        </div>
      </md-layout>
        
      <!-- </md-toolbar> -->

    <md-layout id="spinner-loading" md-align="center" class="HOME__stop_loading">
      <md-spinner id="spinner_" :md-size="120" :md-stroke="1" md-indeterminate class="md-primary HOME__md-spinner"></md-spinner>
      <div class="HOME__md-spinner HOME__logo_div">
        <!-- <img width="58px" height="58px" src="../assets/img/tradelinks.svg" alt="" class="HOME__logo" /> -->
        <!-- <div class="HOME__logo">
          <svg width="77" height="77" viewBox="0 0 77 77" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Group</title>
            <desc>Created using Figma</desc>
            <g id="Canvas" transform="translate(-1586 1931)">
            <g id="Group">
            <g id="Vector">
            <use xlink:href="#path0_fill" transform="translate(1603.96 -1911.3)" fill="#1E88E5"/>
            </g>
            <g id="Vector">
            <use xlink:href="#path1_fill" transform="translate(1586.44 -1930.85)" fill="#1E88E5"/>
            </g>
            </g>
            </g>
            <defs>
            <path id="path0_fill" d="M 40.8409 7.47789L 34.9391 0L 6.18726 0L 0.235115 7.57895C -0.471071 8.64 0.638652 8.69053 0.638652 8.69053L 0.739534 8.69053L 0.789979 11.8232C 0.638654 14.7537 3.4634 16.0168 3.4634 16.0168L 3.41296 34.2568L 1.2944 34.2568C 0.28556 34.3074 0.588207 35.7726 0.588207 35.7726C 0.638649 37.2379 1.49616 36.9347 1.49616 36.9347L 39.7311 36.9347C 40.8913 36.8842 40.5382 35.2674 40.5382 35.2674C 40.5382 34.2568 39.9329 34.2568 39.9329 34.2568L 37.7135 34.2568L 37.7639 16.0168C 40.3869 15.6126 40.3869 12.1263 40.3869 12.1263L 40.3364 8.64C 41.6479 8.48842 40.8409 7.47789 40.8409 7.47789ZM 34.9391 34.2063L 25.6578 34.2063L 25.6578 19.5537C 25.6578 19.5537 25.91 18.5937 24.5481 18.4926C 24.5481 18.4926 23.1357 18.24 23.1862 19.7053L 23.1862 30.8716L 5.78372 30.6695L 5.78372 16.2695C 5.78372 16.2695 7.75096 15.9663 8.25538 14.2989C 8.25538 14.2989 8.70936 13.1874 9.31466 14.2989C 9.31466 14.2989 10.3235 16.5221 13.0474 16.2695C 13.0474 16.2695 15.1659 16.3705 16.1243 14.4505C 16.1243 14.4505 16.5279 13.2884 17.1836 14.4505C 17.1836 14.4505 18.0411 16.32 20.6137 16.32C 20.6137 16.32 23.1862 16.5726 23.8924 14.6021C 23.8924 14.6021 24.5481 13.1368 25.2039 14.5011C 25.2039 14.5011 25.91 16.4716 28.7852 16.3705C 28.7852 16.3705 30.9038 16.4716 31.8622 14.4505C 31.8622 14.4505 32.4171 13.2884 32.9719 14.4C 32.9719 14.4 33.325 15.7642 34.9391 16.0674L 34.9391 34.2063Z"/>
            <path id="path1_fill" d="M 38.0332 0C 17.0494 0 0 17.0274 0 38.0968C 0 59.1663 16.9989 76.1937 38.0332 76.1937C 59.017 76.1937 76.0664 59.1663 76.0664 38.0968C 76.0664 17.0274 59.0675 0 38.0332 0ZM 38.0332 71.3937C 19.6723 71.3937 4.79198 56.4884 4.79198 38.0968C 4.79198 19.7053 19.6723 4.8 38.0332 4.8C 56.394 4.8 71.2744 19.7053 71.2744 38.0968C 71.2744 56.4884 56.4445 71.3937 38.0332 71.3937Z"/>
            </defs>
          </svg>
        </div> -->
      </div>
      <div class="HOME__md-spinner HOME__logo_div">
        <img src="../assets/img/stshopc.png" width="70px"/>
      </div>
    </md-layout>

  </div>
</template>
<script>
  import Sidebar from '../shared-components/sidebar/Sidebar';
  import Toolbar from '../shared-components/toolbar/Toolbar';
  import Footer from '../shared-components/footer/footer';

  export default {
    name: 'Home',
    data() {
      return {
        resourceDepartamentos: this.$api.departamento(this.$resource),
        resourceCliente: this.$api.cliente(this.$resource),
        menuList: [],
        usuarioInfo: {},
        selectedMenu: {},
        isMenuSelected: false,
        empresa: {},
      };
    },
    components: {
      Sidebar,
      Toolbar,
      Footer
    },
    computed: {
      hideMenu() {
        return !this.filteredMenuList.length;
      },
      pageName() {
        return this.$route.name;
      },
      state() {
        return this.$route.name;
      },
    },
    methods: {
      getEmpresa() {
        this.resourceCliente.empresa()
          .then((response) => {
            this.empresa = response.body.empresa;
            localStorage.setItem('empresa', JSON.stringify(this.empresa));
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },
      goWhatsapp(){
        window.open("https://wa.me/" + this.empresa.fax, '_blank');
      },
      toggleSidenav() {
        this.$refs.sidenav.toggle();
      },
      selectItem(index) {
        const element = this.menuList[index];
        this.$refs.menu.$children[index].active = false;
        this.menuList.splice(index, 1);
        this.menuList.splice(0, 0, element);
        this.$refs.menu.$children[0].active = true;
      },
      validateStShop() {
        this.resourceCliente.validacion()
          .then((response) => {
            if(response.data.valido === false) {
              this.$router.push({ name: 'licencia'});
            } 
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },
      getDepartamentos() {
        this.resourceDepartamentos.buscar()
          .then((response) => {
            this.menuList = response.data.data;
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },
      selectMenu(menu) {
        this.isMenuSelected = true;
        this.selectedMenu = menu;
      },
      backMenu() {
        this.isMenuSelected = false;
        this.selectedMenu = {};
      },
    },
    beforeMount() {
      const cart = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : [];
      window.cart = cart;
    },
    
    mounted() {
      this.getDepartamentos();
      if(localStorage.getItem('empresa')) {
        this.empresa = JSON.parse(localStorage.getItem('empresa'));  
      } else {
        this.getEmpresa();
      }
      this.validateStShop();
    },
    beforeDestroy() {
    },
  };
</script>
<style lang="scss">
  @import 'src/config/theme/theme.scss';
  .Home__Wrapper {
    background: white;
    margin: -3em 1em 0 1em;
    min-height: 85vh;
    padding-bottom: 2em;
    position: relative;
  }
  .Home__Wrapper .md-title {
    text-transform: capitalize;
  }
  @media (max-width: 1024px) {
    .Home__Wrapper {
      margin: -3em 0.5em 0 0.5em;
    }
  }
  #spinner-loading {
  }
  .HOME__md-spinner{
      position: absolute;
      top: 47vh;
      left:47vw;
  }
  .HOME__logo_div {
    width:140px;
    height:140px;
    padding: 25px 15px 0 25px;
  }
  .HOME__logo svg path{
    fill: $primary-color;
  }
  .HOME__loading {
    position:fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: #eae9e9;
    opacity: .7;
    z-index: 999;
    display: block !important;
  }
  .HOME__stop_loading {
    display: none !important;
  }
  .md-theme-default.md-toolbar.Toolbar_white_color{
    color: #fff!important;
  }
  .whiteframe {
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  margin:5px;
  padding:10px;
}

</style>



// WEBPACK FOOTER //
// src/spa/Home.vue